import { NOTIFICATION_ACTIONS } from 'state/actions';
import { filterByProperty } from 'helpers/array';

export const initialState = [];

const notificationReducer = (
  state = initialState,
  { type, data: { id, message = '', level = '' } = {} },
) => {
  switch (type) {
    case NOTIFICATION_ACTIONS.NOTIFICATION_ADDED:
      return [...state, { id, message, level }];
    case NOTIFICATION_ACTIONS.NOTIFICATION_REMOVED:
      return [...filterByProperty(state, 'id', id)];
    case NOTIFICATION_ACTIONS.NOTIFICATIONS_CLEARED:
      return [];
    default:
      return state;
  }
};

export default notificationReducer;
